import { render, staticRenderFns } from "./BranchExtension.vue?vue&type=template&id=347344eb&"
import script from "./BranchExtension.vue?vue&type=script&lang=js&"
export * from "./BranchExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports